import React from 'react';
import ContentLoader from 'react-content-loader';

import { Box } from '@lyearn/ui';

const Loader: React.FC = () => {
  return (
    <Box className="w-full flex-grow overflow-hidden">
      <ContentLoader
        backgroundColor="#f3f3f3"
        foregroundColor="var(--interactive-secondary)"
        height={814}
        speed={2}
        viewBox="0 0 340 814"
        width={340}>
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="16" y="16" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="176" y="16" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="16" y="134" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="176" y="134" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="16" y="252" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="176" y="252" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="16" y="370" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="176" y="370" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="16" y="488" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="176" y="488" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="16" y="606" />
        <rect fill="#F2F2F2" height="106" rx="4" width="148" x="176" y="606" />
      </ContentLoader>
    </Box>
  );
};

export default Loader;
